var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5153 24.4966C16.3146 25.4853 15.7782 26.3742 14.997 27.0127C14.2158 27.6512 13.238 28 12.2291 28C11.2202 28 10.2423 27.6512 9.46111 27.0127C8.67994 26.3742 8.14353 25.4853 7.94276 24.4966H16.5153ZM12.2256 0C17.7348 0 22.2747 4.0851 22.6946 9.36861L22.7174 9.75875L22.7261 10.1506L22.7243 16.4594L24.3934 20.9853L24.4371 21.134L24.4651 21.2845L24.4739 21.4402C24.4739 21.9913 24.131 22.4724 23.5606 22.6771L23.3612 22.7348L23.1617 22.7523H1.29638C1.14168 22.7519 0.988275 22.724 0.843263 22.6701C0.341154 22.4864 0.010497 22.0193 0 21.4175L0.00699794 21.2128L0.0664815 20.9853L1.72851 16.4646L1.73201 10.1349L1.73901 9.74126C1.9542 4.28804 6.5799 0 12.2256 0Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBell);
export default __webpack_public_path__ + "static/media/icon-bell.8085bae5.svg";
export { ForwardRef as ReactComponent };